import(/* webpackMode: "eager" */ "/app/lib/StyledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",\"1000\"],\"style\":[\"normal\",\"italic\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-nunito\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MainHeader/utils/logout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/SentryTags/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrimordialProvider"] */ "/app/src/context/primordialProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/styles/global.css");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/styles/GlobalStyles.tsx");
